module.exports = __webpack_public_path__ + "static/media/image_part_008.a46d5598.jpg";